import React, { useEffect, useState } from 'react';
import { bool, arrayOf, number, shape } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { useConfiguration } from '../../context/configurationContext';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { REVIEW_TYPE_OF_PROVIDER, REVIEW_TYPE_OF_CUSTOMER, propTypes } from '../../util/types';
import { ensureCurrentUser, ensureUser } from '../../util/data';
import { withViewport } from '../../util/uiHelpersOld';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
  Heading,
  H2,
  H4,
  Page,
  AvatarLarge,
  NamedLink,
  ListingCard,
  Reviews,
  ButtonTabNavHorizontal,
  LayoutSideNavigation,
  H3,
} from '../../components';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import css from './ProfilePage.module.css';
import { useParams } from 'react-router-dom';

const MAX_MOBILE_SCREEN_WIDTH = 768;

export const AsideContent = props => {
  const { user, displayName, isCurrentUser } = props;
  const firstName = displayName ? displayName.split(' ')[0] : '';
  return (
    <div className={css.asideContent}>
      <AvatarLarge className={css.avatar} user={user} disableProfileLink />
      <H2 as="h1" className={css.mobileHeading}>
        {firstName ? (
          <FormattedMessage id="ProfilePage.mobileHeading" values={{ name: firstName }} />
        ) : null}
      </H2>
      {isCurrentUser ? (
        <>
          <NamedLink className={css.editLinkMobile} name="ProfileSettingsPage">
            <FormattedMessage id="ProfilePage.editProfileLinkMobile" />
          </NamedLink>
          <NamedLink className={css.editLinkDesktop} name="ProfileSettingsPage">
            <FormattedMessage id="ProfilePage.editProfileLinkDesktop" />
          </NamedLink>
        </>
      ) : null}
    </div>
  );
};

export const ReviewsErrorMaybe = props => {
  const { queryReviewsError } = props;
  return queryReviewsError ? (
    <p className={css.error}>
      <FormattedMessage id="ProfilePage.loadingReviewsFailed" />
    </p>
  ) : null;
};

export const MobileReviews = props => {
  const { reviews, partner, queryReviewsError, hasListings } = props;

  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);
  if (!hasListings) {
    return (
      <div className={css.mobileReviews}>
        <H4 as="h2" className={css.mobileReviewsTitle}>
          <FormattedMessage
            id={'ProfilePage.reviewsFromMyCustomersTitleUser'}
            values={{ count: reviewsOfCustomer.length }}
          />
        </H4>
        <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />
        <Reviews reviews={reviewsOfCustomer} />
      </div>
    );
  } else {
    return (
      <div className={css.mobileReviews}>
        <H4 as="h2" className={css.mobileReviewsTitle}>
          <FormattedMessage
            id="ProfilePage.reviewsFromMyCustomersTitle"
            values={{ count: reviewsOfProvider.length }}
          />
        </H4>
        <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />
        <Reviews reviews={reviewsOfProvider} />
        <H4 as="h2" className={css.mobileReviewsTitle}>
          <FormattedMessage
            id={'ProfilePage.reviewsAsACustomerTitle'}
            values={{ count: reviewsOfCustomer.length }}
          />
        </H4>
        <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />
        <Reviews reviews={reviewsOfCustomer} />
      </div>
    );
  }
};

export const DesktopReviews = props => {
  const [showReviewsType, setShowReviewsType] = useState(REVIEW_TYPE_OF_PROVIDER);
  const { reviews, partner, queryReviewsError, hasListings } = props;

  const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
  const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);
  const isReviewTypeProviderSelected = showReviewsType === REVIEW_TYPE_OF_PROVIDER;
  const isReviewTypeCustomerSelected = showReviewsType === REVIEW_TYPE_OF_CUSTOMER;
  let desktopReviewTabs;
  if (!hasListings) {
    desktopReviewTabs = [
      {
        text: (
          <Heading as="h3" rootClassName={css.desktopReviewsTitle}>
            <FormattedMessage
              id={'ProfilePage.reviewsFromMyCustomersTitleUser'}
              values={{ count: reviewsOfCustomer.length }}
            />
          </Heading>
        ),
        selected: isReviewTypeCustomerSelected,
        onClick: () => setShowReviewsType(REVIEW_TYPE_OF_CUSTOMER),
      },
    ];
  } else {
    desktopReviewTabs = [
      {
        text: (
          <Heading as="h3" rootClassName={css.desktopReviewsTitle}>
            <FormattedMessage
              id="ProfilePage.reviewsFromMyCustomersTitle"
              values={{ count: reviewsOfProvider.length }}
            />
          </Heading>
        ),
        selected: isReviewTypeProviderSelected,
        onClick: () => setShowReviewsType(REVIEW_TYPE_OF_PROVIDER),
      },
      {
        text: (
          <Heading as="h3" rootClassName={css.desktopReviewsTitle}>
            <FormattedMessage
              id={'ProfilePage.reviewsAsACustomerTitle'}
              values={{ count: reviewsOfCustomer.length }}
            />
          </Heading>
        ),
        selected: isReviewTypeCustomerSelected,
        onClick: () => setShowReviewsType(REVIEW_TYPE_OF_CUSTOMER),
      },
    ];
  }
  if (!hasListings) {
    return (
      <div className={css.desktopReviews}>
        <div className={css.desktopReviewsWrapper}>
          <Heading as="h3" rootClassName={css.desktopReviewsTitle}>
            <FormattedMessage
              id={'ProfilePage.reviewsFromMyCustomersTitleUser'}
              values={{ count: reviewsOfCustomer.length }}
            />
          </Heading>
          <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />
          <Reviews reviews={reviewsOfCustomer} />
        </div>
      </div>
    );
  } else {
    return (
      <div className={css.desktopReviews}>
        <div className={css.desktopReviewsWrapper}>
          <ButtonTabNavHorizontal className={css.desktopReviewsTabNav} tabs={desktopReviewTabs} />

          <ReviewsErrorMaybe queryReviewsError={queryReviewsError} />

          {isReviewTypeProviderSelected ? (
            <Reviews reviews={reviewsOfProvider} />
          ) : (
            <Reviews reviews={reviewsOfCustomer} />
          )}
        </div>
      </div>
    );
  }
};

export const MainContent = props => {
  const {
    userShowError,
    bio,
    displayName,
    listings,
    queryListingsError,
    reviews,
    queryReviewsError,
    viewport,
    partner,
    ensuredCurrentUser,
    profileUser,
  } = props;

  const { lang } = useParams();

  const hasListings = listings.length > 0;
  const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;
  const hasBio = !!bio;

  const aboutHost =
    lang == 'de'
      ? profileUser?.attributes?.profile?.publicData?.aboutTheHost_de
      : profileUser?.attributes?.profile.publicData?.aboutTheHost;
  const listingsContainerClasses = classNames(css.listingsContainer, {
    [css.withBioMissingAbove]: !hasBio,
  });

  if (userShowError || queryListingsError) {
    return (
      <p className={css.error}>
        <FormattedMessage id="ProfilePage.loadingDataFailed" />
      </p>
    );
  }
  const firstName = displayName ? displayName.split(' ')[0] : '';

  return (
    <div>
      <H2 as="h1" className={css.desktopHeading}>
        <FormattedMessage id="ProfilePage.desktopHeading" values={{ name: firstName }} />
      </H2>
      {/*       {hasBio ? <p className={css.bio}>{bio}</p> : null} */}

      <p className={css.bio}>{aboutHost}</p>
      {hasListings ? (
        <div className={listingsContainerClasses}>
          <H4 as="h2" className={css.listingsTitle}>
            <FormattedMessage id="ProfilePage.listingsTitle" values={{ count: listings.length }} />
          </H4>
          <ul className={css.listings}>
            {listings.map(l => (
              <li className={css.listing} key={l.id.uuid}>
                <ListingCard listing={l} showAuthorInfo={false} />
              </li>
            ))}
          </ul>
        </div>
      ) : null}
      {isMobileLayout ? (
        <MobileReviews
          reviews={reviews}
          queryReviewsError={queryReviewsError}
          partner={partner}
          hasListings={hasListings}
        />
      ) : (
        <DesktopReviews
          reviews={reviews}
          queryReviewsError={queryReviewsError}
          partner={partner}
          hasListings={hasListings}
        />
      )}
    </div>
  );
};

const ProfilePageComponent = props => {
  const config = useConfiguration();
  const { scrollingDisabled, currentUser, userShowError, user, intl, ...rest } = props;
  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const profileUser = ensureUser(user);
  const isCurrentUser =
    ensuredCurrentUser.id && profileUser.id && ensuredCurrentUser.id.uuid === profileUser.id.uuid;
  const { bio, displayName } = profileUser?.attributes?.profile || {};

  const schemaTitleVars = { name: displayName, marketplaceName: config.marketplaceName };
  const schemaTitle = intl.formatMessage({ id: 'ProfilePage.schemaTitle' }, schemaTitleVars);

  if (userShowError && userShowError.status === 404) {
    return <NotFoundPage />;
  }

  const currUser = ensuredCurrentUser?.attributes?.profile?.protectedData?.type
    ? ensuredCurrentUser?.attributes?.profile?.protectedData?.type
    : '';
  const partner = currUser;

  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ProfilePage',
        name: schemaTitle,
      }}
      noindex
    >
      <LayoutSideNavigation
        sideNavClassName={css.aside}
        topbar={<TopbarContainer currentPage="ProfilePage" />}
        sideNav={
          <AsideContent user={user} isCurrentUser={isCurrentUser} displayName={displayName} />
        }
        footer={<FooterContainer />}
      >
        <MainContent
          bio={bio}
          displayName={displayName}
          userShowError={userShowError}
          {...rest}
          partner={partner}
          ensuredCurrentUser={ensuredCurrentUser}
          profileUser={profileUser}
        />
      </LayoutSideNavigation>
    </Page>
  );
};

ProfilePageComponent.defaultProps = {
  currentUser: null,
  user: null,
  userShowError: null,
  queryListingsError: null,
  reviews: [],
  queryReviewsError: null,
};

ProfilePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  currentUser: propTypes.currentUser,
  user: propTypes.user,
  userShowError: propTypes.error,
  queryListingsError: propTypes.error,
  listings: arrayOf(propTypes.listing).isRequired,
  reviews: arrayOf(propTypes.review),
  queryReviewsError: propTypes.error,

  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    userId,
    userShowError,
    queryListingsError,
    userListingRefs,
    reviews,
    queryReviewsError,
  } = state.ProfilePage;
  const userMatches = getMarketplaceEntities(state, [{ type: 'user', id: userId }]);
  const user = userMatches.length === 1 ? userMatches[0] : null;
  const listings = getMarketplaceEntities(state, userListingRefs);
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    user,
    userShowError,
    queryListingsError,
    listings,
    reviews,
    queryReviewsError,
  };
};

const ProfilePage = compose(
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(ProfilePageComponent);

export default ProfilePage;
